class ManageTestSuiteController {
    constructor(ManageTestSuiteServiceApi, AppServiceApi, UserDetailsApi, toastr, SettingsService, moment, $uibModal, ReportUtils) {
        this.$onInit = () => {
            this.init();
        };
        this.expiryRenderer = (row) => {
            let rowData = row.data;
            // row.data.expiryClass = 'traffic-off';
            let expiry = [
                '<span class="traffic-circle ',
                this.state.statusIconSize,
                '"',
                'uib-popover="No expiry date for this Suite"',
                'popover-placement="right"',
                'popover-append-to-body="true"',
                'popover-animation popover-trigger="\'mouseenter\'"',
                '></span>'
            ].join('');
            let colour;
            let popupText = '';
            let expiryDate = '';
            // @ts-ignore no entry for _.isNill in the lodash interface
            if (!_.isNil(row.data.ExpiryDate)) {
                // if (!row.data.ExpiryDate !== undefined && row.data.ExpiryDate !== null) {
                const expiryMoment = this.moment(row.data.ExpiryDate);
                const today = this.moment();
                expiryDate = expiryMoment.format(this.state.DateFormats.DateFormat);
                colour = 'traffic-success';
                popupText = 'Will expire on ';
                if (today.isAfter(expiryMoment)) {
                    colour = 'traffic-danger';
                    popupText = 'Expired on ';
                }
                else if (expiryMoment.diff(today, 'days') < this.state.expiryLimit) {
                    colour = 'traffic-warning';
                    popupText = 'Expiring on ';
                }
                expiry = [
                    '<span class="traffic-circle ',
                    this.state.statusIconSize,
                    ' ',
                    colour,
                    '-bg"',
                    'uib-popover="',
                    popupText,
                    expiryDate,
                    '"',
                    'popover-placement="right"',
                    'popover-append-to-body="true"',
                    'popover-animation popover-trigger="\'mouseenter\'"',
                    '></span>'
                ].join('');
            }
            if (colour !== undefined) {
                rowData.expiryClass = colour;
            }
            rowData.popupText = popupText + expiryDate;
            return expiry;
        };
        this.nameRenderer = (response) => {
            let testSuite = response.data;
            const name = [
                '<span',
                'ng-if="!vm.state.clickableEdit">',
                testSuite.TestSuiteName,
                '</span><a ng-href=""',
                'class="space-top pointer"',
                'ng-if="vm.state.clickableEdit"',
                'ng-click="vm.editTestSuite(data)">',
                testSuite.TestSuiteName,
                '</a>'
            ].join(' ');
            return name;
        };
        this.testVariableRenderer = (response) => {
            let testSuite = response.data;
            return testSuite.TestCaseVariableCount > 0 ? 'Yes' : 'No';
        };
        this.scriptCellRenderer = (response) => {
            let testSuite = response.data;
            return testSuite.Script ? 'Yes' : 'No';
        };
        this.xmlCellRenderer = (response) => {
            let testSuite = response.data;
            const xml = '<p>' + this.xmlReplace(testSuite.TestPlanData) + '</p>';
            return xml;
        };
        this.xmlReplace = (str) => {
            // var text = String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/&lt;Arguments&gt;/g, '&lt;Arguments&gt;<br />').replace(/&lt;\/Arguments&gt;/g, '<br />&lt;/Arguments&gt;').replace(/&lt;controlport&gt;/g, '<br />&lt;controlport&gt;');
            // Put new lines in to the string where they exist.
            const text = String(str).replace(/\n/g, '<br />');
            return text;
        };
        this.statusCellRenderer = () => {
            const isDeleted = '<div><p ng-if="!data.IsDeleted">No</p><p ng-if="data.IsDeleted">Yes</p></div>';
            return isDeleted;
        };
        this.actionsCellRenderer = () => {
            const testCaseData = [
                '<span class="btn btn-info btn-xs"',
                'ng-if="!data.IsDeleted"',
                'ng-click="vm.editTestCaseData(data)"',
                'uib-popover="Edit Test Cases"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '<i class="glyphicon glyphicon-tag"></i>',
                '</span>'
            ].join(' ');
            const edit = [
                '<span class="btn btn-info btn-xs"',
                'ng-click="vm.editTestSuite(data)"',
                'uib-popover="Edit Test Suite"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '<i class="glyphicon glyphicon-pencil"></i>',
                '</span > '
            ].join(' ');
            const deleteSuite = [
                '<delete-test-suite test-suite="data" on-success="vm.filterInThis()" class="display-flex"></delete-test-suite>'
            ].join();
            // Decide what buttons should be enabled
            // var includedButtons = testInfo + edit + deleteSuite;
            let includedButtons = edit + deleteSuite;
            if (this.state.systemInfo.ManagedTesterModule) {
                // includedButtons = testMetadata + testCaseData + testInfo + edit + deleteSuite;
                includedButtons = testCaseData + edit + deleteSuite;
            }
            return '<div class="ag-grid-actions-container">' + includedButtons + '</div>';
        };
        this.filterInThis = () => {
            this.getTestSuites();
        };
        this.getTestSuites = () => {
            this.ManageTestSuiteServiceApi.getAllTestSuites().then(response => {
                let suites = response.data;
                this.data.testSuites = [];
                suites.forEach(suite => {
                    let fullSuite = {};
                    fullSuite.Description = suite.Description;
                    fullSuite.expiryClass = '';
                    fullSuite.ExpiryDate = suite.ExpiryDate;
                    fullSuite.Id = suite.Id;
                    fullSuite.IsDeleted = suite.IsDeleted;
                    fullSuite.popupText = '';
                    fullSuite.TestPlanData = suite.TestPlanData;
                    fullSuite.TestSuiteName = suite.TestSuiteName;
                    fullSuite.TestSuiteUid = suite.TestSuiteUid;
                    fullSuite.TestSuiteXML = suite.TestSuiteXML;
                    fullSuite.UserName = suite.UserName;
                    fullSuite.TestCaseVariableCount = suite.TestCaseVariableCount;
                    this.data.testSuites.push(fullSuite);
                    fullSuite.Script = suite.Script;
                });
                let filteredSuites = _.filter(this.data.testSuites, suite => {
                    // @ts-ignore : no support for _.isNil in the lodash interface.
                    return !_.isNil(suite.ExpiryDate);
                });
                let OnlyActiveSuites = _.filter(this.data.testSuites, suite => {
                    return suite.IsDeleted === false;
                });
                this.data.filterOptions = {
                    allTestSuites: this.data.testSuites,
                    expiryOnly: filteredSuites,
                    activeOnly: OnlyActiveSuites
                };
                // this.data.testSuites = suites;
                this.filterRows();
                this.gridOptions.api.setRowData(this.data.testSuites);
            });
        };
        this.toggleExpiryOnly = () => {
            this.state.expiryOnly = !this.state.expiryOnly;
            this.filterRows();
            this.gridOptions.api.setRowData(this.data.testSuites);
        };
        this.toggleActiveOnly = () => {
            this.state.activeOnly = !this.state.activeOnly;
            this.filterRows();
            this.gridOptions.api.setRowData(this.data.testSuites);
        };
        this.filterRows = () => {
            if (this.state.expiryOnly) {
                this.data.testSuites = this.data.filterOptions.expiryOnly;
            }
            else {
                this.data.testSuites = this.data.filterOptions.allTestSuites;
            }
            if (this.state.activeOnly) {
                this.data.testSuites = this.data.filterOptions.activeOnly;
            }
            else {
                this.data.testSuites = this.data.filterOptions.allTestSuites;
            }
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.exportCsv = () => {
            // TODO
        };
        this.editTestCaseData = (suite) => {
            let suiteEditModal = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'editTestCaseComponent',
                size: 'md',
                resolve: {
                    suite: () => {
                        return suite;
                    },
                    visibleExpirys: () => {
                        return this.state.visibleExpirys;
                    }
                }
            });
            suiteEditModal.result.then(() => {
                this.getTestSuites();
            });
        };
        this.editTestSuite = (suite) => {
            let params = {};
            let suiteEditModal = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'addTestSuiteComponent',
                size: 'md',
                resolve: {
                    suite: () => {
                        // console.log(suite);
                        return suite;
                    },
                    // Specify the datepicker options here as they have been loaded on this page - we ensure we have them in the modal and save a trip to fetch.
                    datepickerOptions: () => {
                        return {
                            // TODO : get the type here
                            alwaysShowCalendars: true,
                            singleDatePicker: true,
                            format: this.state.DateFormats.DateFormat
                        };
                    },
                    visibleExpirys: () => {
                        return this.state.visibleExpirys;
                    },
                    expiryLimit: () => {
                        return this.state.expiryLimit;
                    }
                }
            });
            suiteEditModal.result.then(
            // close callback
            (closeResult) => {
                // Perform close actions
                this.getTestSuites();
                const msg = ['Test Suite ', closeResult.modalAction, '!'].join('');
                this.toastr.info(msg);
            }, 
            // dismiss callback
            (modalAction) => {
                // Perform cancel/dismiss actions
            });
        };
        this.addTestSuite = () => {
            let emptysuite = {};
            emptysuite.Id = -1;
            emptysuite.IsDeleted = false;
            this.editTestSuite(emptysuite);
        };
        this.init = () => {
            this.userDetails = {};
            this.data = {
                filterOptions: {},
                testSuites: {}
            };
            this.state = {
                clickableEdit: true,
                expiryOnly: false,
                activeOnly: false,
                statusIconSize: 'medium',
                DateFormats: {
                    DateTimeFormat: '',
                    DateFormat: '',
                    TimeFormat: ''
                },
                expiryLimit: 0,
                systemInfo: {},
                visibleExpirys: ''
            };
            this.rowCount = 0;
            this.columnDefs = [
                {
                    headerName: '',
                    width: 50,
                    minWidth: 50,
                    field: 'ExpiryDate',
                    cellClass: 'text-center',
                    cellRenderer: this.expiryRenderer,
                    suppressMovable: true,
                    suppressMenu: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Id',
                    minWidth: 50,
                    width: 50,
                    field: 'Id',
                    suppressMovable: true,
                    suppressMenu: true,
                    resizable: false,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Test Variable',
                    minWidth: 90,
                    width: 90,
                    cellRenderer: this.testVariableRenderer
                },
                {
                    headerName: 'Name',
                    minWidth: 110,
                    field: 'TestSuiteName',
                    cellRenderer: this.nameRenderer,
                    sort: 'asc',
                    suppressMovable: true
                },
                {
                    headerName: 'Suite UID',
                    minWidth: 132,
                    field: 'TestSuiteUid'
                },
                {
                    headerName: 'Suite Data',
                    cellStyle: { 'white-space': 'normal' },
                    minWidth: 132,
                    field: 'TestSuiteXML',
                    cellRenderer: this.xmlCellRenderer
                },
                {
                    headerName: 'Editable via Script',
                    minWidth: 60,
                    cellRenderer: this.scriptCellRenderer
                },
                {
                    headerName: 'Actions',
                    width: 108,
                    minWidth: 108,
                    cellRenderer: this.actionsCellRenderer,
                    sortable: false,
                    suppressMenu: true,
                    resizable: false,
                    suppressMovable: true
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.state.visibleExpirys =
                    appSettings.TestSuiteExpirationVisibleClasses;
                this.state.expiryLimit = appSettings.TestSuiteExpiryWarningDayLimit;
            });
            this.UserDetailsApi.get().then((data) => {
                let user = data;
                this.userDetails = user;
                this.getTestSuites();
            });
            this.AppServiceApi.systemInfo().then((info) => {
                let sysInfo = info.data;
                this.state.systemInfo = sysInfo;
                return;
            });
        };
        this.ManageTestSuiteServiceApi = ManageTestSuiteServiceApi;
        this.AppServiceApi = AppServiceApi;
        this.UserDetailsApi = UserDetailsApi;
        this.toastr = toastr;
        this.SettingsService = SettingsService;
        this.moment = moment;
        this.uibModal = $uibModal;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('manageTestSuite', {
    bindings: {},
    templateUrl: 'scripts/app/partials/ManageTestSuites/manage-test-suite.tpl.html',
    controllerAs: 'vm',
    controller: ManageTestSuiteController
});
